export default __webpack_public_path__ + "static/media/macaroons.40f9c20c.png";